import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  QUERIES,
  WithChildren,
  createResponseContext,
  initialQueryResponse,
  stringifyRequestQuery,
} from '../../../../../../_metronic/helpers'
import { useModal } from '../../../../../components'
import { FeriadoList } from '../../core/_models'
import { getFeriados } from '../../core/_requests'
import { useQueryRequest } from './QueryRequestProvider'

const QueryResponseContext = createResponseContext<FeriadoList>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.FERIADOS_LIST, query], () => getFeriados(query), {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
